import Service from "./Service";

export default class StripeService extends Service {
    constructor() {
        super();
    }

    executePayment(token, state) {
        return this.axios.post('/charge', {token, state});
    }


    executeQuotePayment(quoteId, token) {
        return this.axios.post(`/quotes/pay/${quoteId}/charge`, token);
    }

    executeAdditionalPayment(token, payment) {
        return this.axios.post('/confirm-payment', {token, payment});
    }

    executeNonStrongPayment(token, state) {
        return this.axios.post('/charge-regular', {token, state});
    }
}
